/**
 * NOTE: For compatibility across platforms all calls **must** return a
 * `Promise` object!
 */

/** */
export interface VolumeInterface {
    /**
     * **Feature:** Set the volume
     * @param volume - On a scale from 0 to 100
     * @param transitionTime - in milliseconds
     */
    setVolume(volume: number, transitionTime: number): Promise<void>;
}

export function supportsVolume(platform: unknown): platform is VolumeInterface {
    return platform instanceof Object && 'setVolume' in platform;
}
